var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticket-order"},[_c('operation-page',{attrs:{"title":"订单确认","btn":"确认支付"},on:{"next":_vm.onSubmit}},[_c('ticket-confirm-card',{attrs:{"ticketId":_vm.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }